import { signIn } from 'next-auth/client';

const redirectToLoginPage = ({ callbackUrl } = {}) => {
  if (callbackUrl) return signIn(null, { callbackUrl });

  return signIn();
};

export default redirectToLoginPage;
